import i18n from "../i18n";

/**
 * Return blogs localized to the current language (English-only fallback).
 */
export const getLocalizedBlogs = (blogData, currentLanguage = "en") => {
  if (!Array.isArray(blogData)) return [];

  return blogData.map((blog) => {
    if (typeof blog.title === "string") return blog;

    return {
      ...blog,
      title: blog.title[currentLanguage] || blog.title.en || blog.title,
      destination: blog.destination[currentLanguage] || blog.destination.en || blog.destination,
      content: blog.content[currentLanguage] || blog.content.en || blog.content,
      summary: blog.summary?.[currentLanguage] || blog.summary?.en || blog.summary
    };
  });
};

/**
 * Return a single blog localized to the current language (English-only fallback).
 */
export const getLocalizedBlog = (blog, currentLanguage = "en") => {
  if (!blog) return null;
  if (typeof blog.title === "string") return blog;

  return {
    ...blog,
    title: blog.title[currentLanguage] || blog.title.en || blog.title,
    destination: blog.destination[currentLanguage] || blog.destination.en || blog.destination,
    content: blog.content[currentLanguage] || blog.content.en || blog.content,
    summary: blog.summary?.[currentLanguage] || blog.summary?.en || blog.summary
  };
};

/**
 * Get current language (default en).
 */
export const getCurrentLanguage = () => i18n.language || "en";

/**
 * Estimate reading time in minutes from HTML content.
 */
export const calculateReadTime = (content) => {
  if (!content) return 0;
  const textContent = content.replace(/<[^>]*>/g, "");
  const wordsPerMinute = 200;
  const wordCount = textContent.split(/\s+/).length;
  return Math.ceil(wordCount / wordsPerMinute);
};

/**
 * Generate an excerpt from HTML content.
 */
export const generateExcerpt = (content, maxLength = 150) => {
  if (!content) return "";
  const textContent = content.replace(/<[^>]*>/g, "");
  if (textContent.length <= maxLength) return textContent;
  const excerpt = textContent.substring(0, maxLength);
  const lastSpaceIndex = excerpt.lastIndexOf(" ");
  return lastSpaceIndex > 0 ? `${excerpt.substring(0, lastSpaceIndex)}...` : `${excerpt}...`;
};

/**
 * Format a mock blog date based on index.
 */
export const formatBlogDate = (blogIndex, currentLanguage = "en") => {
  const day = String(15 + blogIndex * 7).padStart(2, "0");
  const monthNames = {
    en: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
  };
  const month = monthNames[currentLanguage]?.[blogIndex % 12] || monthNames.en[blogIndex % 12];
  return `${day} ${month} 2025`;
};
